import React from "react"
import { Container, Modal, Accordion } from "react-bootstrap"
import closeIcon from "../../icons/icon/close.svg"

export default function OcrBillInfoModal({ show, onClose }) {

    return (
        <Modal
            aria-modal="true"
            role="dialog"
            show={show}
            centered={true}
            className='select-popup modal-pictures ocr-bill-info-modal'
            animation={false}
            fullscreen={true}
            backdrop={false}
            aria-label="Quali dati vengono recuperati?"
        >
            <Container fluid className='title d-flex justify-content-between align-items-center'>
                <div className='field-name'>
                    Quali dati vengono recuperati?
                </div>
            </Container>

            <Container fluid className="p-3">
                <Accordion className="" defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <span className="ocr-strong">Da quali fornitori è possibile recuperare i dati?</span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="ocr-bill-info-modal-list">
                                È possibile recuperare i dati dei seguenti fornitori:
                                <br/><br/>
                                <div className="flex flex-column">
                                    {[
                                        "Enel", "Acea", "Dolomiti", "Edison", "Enegan", "Engie", "Eni", "Eon", "Estra", 
                                        "Hera", "Iberdrola", "NeN", "Octopus Energy", "Optima", "PosteEnergia", "Pulsee", 
                                        "Sen", "Sorgenia", "A2A", "Illumia", "Iren", "Sinergy", "WindTre"
                                    ].map((word, index) => (
                                        <div 
                                            key={index}
                                            className="mr-4 my-1 px-2 py-1"
                                            style={{
                                                display: "inline-block",
                                                backgroundColor: "#FFFFFF",
                                                color: "#0047CC",
                                                border: "1px solid transparent",
                                                borderRadius: "16px"
                                            }}
                                        >
                                            {word}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <span className="ocr-strong">Quali dati si possono recuperare?</span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="ocr-bill-info-modal-list">
                                È possibile recuperare i seguenti dati tramite scansione della bolletta:
                                <br/><br/>
                                <ul>
                                    <li>Nome e cognome</li>
                                    <li>Città e CAP</li>
                                    <li>Potenza del contatore <span className="list-item-details">(Recuperato da bolletta Luce)</span></li>
                                    <li>Consumo effettivo annuo* <span className="list-item-details">(Recuperato considerando la somma degli ultimi 12 mesi di consumi)</span></li>
                                    <li>Costo della fornitura elettrica* <span className="list-item-details">(Recuperato tramite una stima basata sui consumi)</span></li>
                                </ul>
                            </div>
                            <p className="ocr-strong" style={{ fontSize: "14px", fontWeight:"700", lineHeight:"21px", letterSpacing:"0", color: "#0047CC" }}>
                                Alcuni dati recuperati dalla scansione potrebbero non essere veritieri, controllali sempre con attenzione!
                            </p>
                            <p style={{ fontSize: "12px", fontWeight:"400", lineHeight:"21px", letterSpacing:"0", color: "#1C1E20" }}>
                                * La stima dei dati potrebbe non essere accurata se non hai almeno 12 mesi di consumi registrati con lo stesso fornitore 
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <div style={{ position:"absolute", right:"16px", top: "16px", zIndex: 2147483647}} 
                    role="button" 
                    aria-label="Chiudi" 
                    className='accent' 
                    onKeyDown={(e) => { if (e.key === "Enter" || e.code == "Space" || e.keyCode == 32) onClose() }}
                    onClick={onClose} 
                    tabIndex={0}>
                    <img height={14} src={closeIcon} alt='' role="presentation" />
                </div>
            </Container>
        </Modal>
    )
}
